import React from 'react';
import './Spinner.css';

const Spinner = ({ size }) => {
  let clase = 'cargador';
  if (size === 'Big') {
    clase = 'cargador cargadorBig';
  } else if (size === 'Min') {
    clase = 'cargador cargadorMin';
  }

  return (
    <div className="col-pxxxl-50 col-pxxl-32 col-pxl-20 col-pl-20 col-pm-16 col-ps-16 col-pxs-16 col-pxxs-16 col-xxl-12 col-xl-12 col-l-12 col-m-12 col-s-12 col-xs-12 col-xxs-12 contenedorCargador margenInferiorMin">
      <div className={clase} />
    </div>
  );
};

export { Spinner };
